import Select from 'react-select'
import React, { useState } from 'react'
import { DatePicker, Dropdown, Menu } from 'antd'
import { useHistory, Switch, Route } from 'react-router-dom'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { useToggle, useListData, stringifyDate, usePet } from '../../modules'

import Modal from '../../components/reusable/modal'
import Receive from '../../components/reusable/receive'
import Confirm from '../../components/reusable/confirm'
import Patient from '../../components/reusable/patient'
import SendFor from '../../components/reusable/sendFor'

import Medication from '../../components/drawers/medication'

const { RangePicker } = DatePicker

const Forward = ({ visible, toggle, fwd, path }) => {    
    const history = useHistory()

    const navigateTo = lnk => history.push(lnk)

    return (
        <Modal
            w={ 400 }
            title="Forwarded Patient"
            toggle={toggle}
            visible={visible}>     
            <div className="border-b-2 border-gray-200 w-full pb-2">
                <p className="font-medium text-sm mb-0">By { fwd?.sentBy?.name } from { fwd?.source }</p>
                <p className="font-light text-xs mb-0">{ stringifyDate(fwd?.sentOn) }</p>
            </div>
            <p className="pt-2">{ fwd?.description }</p>
            <div className="text-right border-t-2 border-gray-200 w-full py-2">
            </div>
            <div className="flex justify-end">
                <Dropdown
                    overlay={
                        <Menu>
                            <Menu.Item onClick={ () => navigateTo(`${path}/forwards/investigations`) }>Send For Investigations</Menu.Item>
                            <Menu.Item onClick={ () => navigateTo(`${path}/forwards/treatment`) }>Send For Treatment</Menu.Item>
                            <Menu.Item onClick={ () => navigateTo(`${path}/forwards/medication`) }>Send For Medication</Menu.Item>
                            <Menu.Item onClick={ () => navigateTo(`${path}/forwards/items`) }>Request Items</Menu.Item>
                        </Menu>
                    }>
                    <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Actions</button>
                </Dropdown>
                <button onClick={ toggle } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
} 

const Referrals = ({ path, destination }) => {
    const [si, setSi] = useState()
    const [ranges, setRanges] = useState()
    const [string, setString] = useState('')
    const [selected, setSelected] = useState()
    const [groups, setGroups] = useState([])

    const [forward, toggleForward] = useToggle()

    const [
        { loading, error, fetch: fetchDocuments },
        { list: attachments = [] },
        { page, limit, navigate, Paginate }
    ] = useListData('documents', ranges ? {
        name: si?.label,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { name: si?.label }, { notify: true })

    const [
        { loading: dLoading, error: dError },
        { list: documents = [] }
    ] = useListData('pointOfSaleItems', { category: 'Documents' }, { notify: true }, 'items', 50)

    const [{ loading: rLoading }, markAsSeen] = usePet('markForwardAsSeen', { id: selected?._id, destination }, { notify: true, callback: (_, notif, ops) => {
        notif('Marked as Seen', ops('success'))
        refresh()
    }, manual: true, load: { msg: 'Saving changes...' } })

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const filterByDocument = doc => {
        setSi(doc)
        refresh()
    }

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const getForward = item => {
        let forward = item.forwards.find(fwd => fwd.destination === destination)
        return forward
    }

    const markForwardAsSeen = itm => {
        setSelected(itm)
        Confirm({
            title: 'Mark Forward as Seen?',
            message: 'Please confirm before performing this action',
            okText: 'Mark As Seen',
            onOk: markAsSeen
        })
    }

    const toggleFwd = itm => {
        setSelected(itm)
        toggleForward()
    }
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => searchSent(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-ssearch"
                    type="text"
                    placeholder="Search for item" />
                <RangePicker onChange={selectRange} />
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800 mb-1">Attached Documents</h2>
                    </span>
                    <span className="flex items-center justify-between">
                        <Receive
                            loading={dLoading}
                            error={dError}>
                            <Select
                                value={ si }
                                onChange={filterByDocument}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={[{ label: 'All', value: 'All' }, ...documents.map(item => ({ label: item.name, value: item._id }))]}
                                placeholder="Filter By Document Type" />
                        </Receive>
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={loading}
                        error={error}>
                        {
                            attachments?.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Document</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                attachments.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {((page - 1) * limit) + (key + 1)}.
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ item?.patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <p className="mb-0">{ item?.item?.name }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <p className={ `text-${ item.filled ? 'green' : 'yellow'}-500 text-xs mb-0` }>{ item.filled? 'Filled' : 'Pending' }</p>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <div className="text-center">
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            <Menu.Item onClick={ () => toggleFwd(item) }>View</Menu.Item>
                                                                            { !item.seen && <Menu.Item disabled={ rLoading } onClick={ () => markForwardAsSeen(item) }>Mark as Seen</Menu.Item> }
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No patients { string.trim().length > 2 ? `matching "${string}"` : "" } have been forwarded here</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route path={ `${path}/forwards/investigations` }>
                    <SendFor
                        {...{ loading, error, groups, tab: "0" }}
                        department="InPatient"
                        source={ path }
                        group="Investigations"
                        attachedTo={ selected?._id }
                        patient={selected?.patient} />
                </Route>
                <Route path={ `${path}/forwards/treatment` }>
                    <SendFor
                        {...{ loading, error, groups, tab: "0" }}
                        department="InPatient"
                        source={ path }
                        group="Treatment"
                        attachedTo={ selected?._id }
                        patient={selected?.patient} />
                </Route>
                <Route path={ `${path}/forwards/medication` }>
                    <Medication
                        {...{ loading, error, groups, tab: "0" }}
                        department="InPatient"
                        source={ path }
                        attachedTo={ selected?._id }
                        patient={selected?.patient} />
                </Route>
            </Switch>
        </div>
    )
}

export default Referrals